import { Box, Card, CardContent, Skeleton } from '@mui/material';
import { IssuesTable as SkeletonIssuesTable } from '../../../../common/dashboards/components/skeletons/IssuesTable';
import { LoadMore as SkeletonLoadMore } from '../../../../common/dashboards/components/skeletons/LoadMore';

export const Issues = () => {
  return (
    <Card>
      <CardContent>
        <Skeleton variant="rectangular" width={250} height={42} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Skeleton variant="rectangular" width={370} height={28} />
          <Skeleton variant="rectangular" width={250} height={28} />
        </Box>
        {Array(4)
          .fill('')
          .map((_, idx) => {
            return (
              <Box key={idx} sx={{ mt: 2 }}>
                {idx === 0 && (
                  <Box sx={{ mb: 4 }}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                    <Box sx={{ p: 2 }}>
                      <SkeletonIssuesTable />
                      <SkeletonLoadMore />
                    </Box>
                  </Box>
                )}
                {idx !== 0 && <Skeleton variant="rectangular" width="100%" height={48} />}
              </Box>
            );
          })}
      </CardContent>
    </Card>
  );
};
